import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { Box, Stack } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { Alert, Button, Typography } from "@platform/design-system";
import { submitEvent } from "@platform/browser-logger";
import { useSignedInUser } from "@platform/user/client";

import { ROUTE_NAMES } from "../../constants";
import { DualRfpsTables } from "../../components/DualRfpsTables";
import { useMainRfpsPageDataV2 } from "../../hooks/useMainRfpsPageDataV2";
import { isInternalUser } from "../../utils";

interface RFPsProps {
  brokerId?: string | number;
  isBrokerPartner?: boolean;
  isDraftList?: boolean;
}

const RFPs: React.FC<RFPsProps> = ({
  brokerId,
  isBrokerPartner = false,
  isDraftList = false,
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { role } = useSignedInUser();
  const internalUser = isInternalUser(role);
  const [error, setError] = useState<string | null>(null);

  const data = useMainRfpsPageDataV2({
    brokerId,
    isBrokerPartner,
    isDraftList,
    setError,
  });

  return (
    <>
      {error && (
        <Box mt={2} mb={2}>
          <Alert severity="error">{error}</Alert>
        </Box>
      )}
      <Stack direction="row" justifyContent="space-between">
        {!isBrokerPartner && (
          <Box>
            <Typography variant="display-medium">RFPs</Typography>
          </Box>
        )}
        {!internalUser && (
          <Stack display="grid" gridTemplateColumns="repeat(5,1fr)">
            <Box gridColumn={5} mb={2}>
              <Button
                variant="primary"
                startIcon={<AddIcon />}
                onClick={() => {
                  submitEvent("Start RFP");
                  navigate(`/${ROUTE_NAMES.CLIENT_SELECTION}` as const, {
                    state: { prevPath: location.pathname },
                  });
                }}
              >
                START RFP
              </Button>
            </Box>
          </Stack>
        )}
      </Stack>
      <DualRfpsTables isBrokerPartner={isBrokerPartner} data={data} />
    </>
  );
};

export default RFPs;
